import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    fieldTaxonomy: {
      marginTop: theme.spacing(0.25),
      minHeight: 167,
    },
  }),
  {
    name: 'IndustryTopicSwitchPopupForm',
  }
);
